<template>
  <b-modal
      v-if="selectedCode"
      id="loopStatus"
      hide-backdrop
      content-class="shadow"
      centered
      :title="selectedCode"
      size="lg"
    >
    <b-table
      id="my-table-loop-status"
      ref="loop-status-table"
      v-if="showTable"
      bordered
      hover
      :items="getLoopTableData"
      :fields="fields"
      class="text-center"
    >
      <template v-slot:cell(status)="row">
        <i v-if="row.item.status" class="fa fa-check-circle fa-lg text-success" aria-hidden="true"></i>
        <i v-else class="fa fa-times fa-lg text-danger" aria-hidden="true"></i>
      </template>

      <template v-slot:cell(actions)="row">
        <div v-if="row.item.status">
          <b-button size="sm">
            <i class="fa fa-edit" aria-hidden="true" @click="goToLoopForm(row.item.name)">Modifier</i>
          </b-button>
          <b-button size="sm" variant="danger">
            <i class="fa fa-trash" aria-hidden="true"></i>
          </b-button>
        </div>
        <div v-else>
          <b-button size="sm" variant="success" @click="goToLoopForm(row.item.name)">
            <i class="fa fa-plus" aria-hidden="true">Ajouter</i>
          </b-button>
        </div>
      </template>
    </b-table>

    <ExternalForm v-if="showExternalForm" />
    <InternalForm v-if="showInternalForm" />
    <TradingForm v-if="showTradingForm" />
  </b-modal>
</template>

<script>
import { Loops } from '../../core/services/loops'
import ExternalForm from '../kanban/ExternalForm.vue'
import InternalForm from '../kanban/InternalForm.vue'
import TradingForm from '../kanban/TradingForm.vue'
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

export default {
  name: 'LoopStatusModal',
  data() {
    return {
      isBusy: false,
      showTable: false,
      showExternalForm: false,
      showInternalForm: false,
      showTradingForm: false,
      fields: [
        { key: 'name', label: 'Loop', sortable: true },
        { key: 'status', label: 'Actif', sortable: true },
        { key: 'actions', label: 'Actions', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedCode']),
    ...mapGetters({
      form: 'getFormKanban'
    })
  },
  methods: {
    getLoopTableData() {
      let data = []
      Loops.map((loop, index) => {
        const isActive = this.form.loops.includes(loop)
        data.push({ loop_id: index, name: loop, status: isActive })
      })
      this.showTable = true
      return data
    },
    goToLoopForm(loopName) {
      this.showTable = false

      if (loopName === 'loop_external') {
        this.showExternalForm = true
      } else if (loopName === 'loop_usual_components') {
        this.showInternalForm = true
      } else if (loopName === 'loop_trading') {
        this.showTradingForm = true
      }
    }
  },
  mounted: function() {
    this.getLoopTableData()

  },
  components: { ExternalForm, InternalForm, TradingForm }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/supply/LoopStatusModal.vue